export default __webpack_public_path__ + "static/media/button-sipat-nexa.7606ea3a.svg";